import { compose } from 'redux';
import { connect } from 'react-redux';
import CountdownView from '../common/countdown/countdownView';
import { goToItems } from '../common/navigation/navigationActions';
import { RAN } from '../constants/measure';
import AvatarView from '../common/avatar/avatarView';
import withAvatar from '../common/avatar/withAvatar';
import { getMeasureType } from '../common/utils/urlParsers';
import { getAvatarPosition } from '../common/alex/AlexUtils';

const mapDispatchToProps = (dispatch, ownProps) => {
    const measureType = getMeasureType(ownProps.location.pathname);
    return {
        onEndCounting: () => {
            dispatch(goToItems(RAN.MEASURE, measureType));
        },
    };
};

const avatarMapStateToProps = () => {
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        defaultViewPosition: AvatarView.Position.LOWER_LEFT,
    };
    const position = getAvatarPosition(positionConfig);
    return {
        position,
        animateAlex: true,
    };
};

const RANCountdownContainer = compose(
    connect(null, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(CountdownView);

export default RANCountdownContainer;
